import { render, staticRenderFns } from "./Startseite.vue?vue&type=template&id=2f97a89b&scoped=true&"
import script from "./Startseite.vue?vue&type=script&lang=js&"
export * from "./Startseite.vue?vue&type=script&lang=js&"
import style0 from "./Startseite.vue?vue&type=style&index=0&id=2f97a89b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97a89b",
  null
  
)

export default component.exports